'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useCallback } from 'react';
import { useProvider } from '@provider-directory/contexts/ProviderContext';
import { useSearch } from '@provider-directory/contexts/ProviderSearchContext';
import { SEARCH_RESULTS_PATH_REGEX } from '@provider-directory/models/navigation.model';
import { parseSearchParams } from '@provider-directory/types/search.model';
import { useAnalytics } from '../components/analytics/analytics-provider';

export type ConversionClickHandler = (href: string) => void;

export const useDecisionTreeConversionClick = (): ConversionClickHandler => {
  const { provider } = useProvider();
  const { specialtyNames } = useSearch();
  const analytics = useAnalytics();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  return useCallback(
    (href: string) => {
      const linkContextPage =
        SEARCH_RESULTS_PATH_REGEX.exec(pathname) ||
        pathname.startsWith('/providers/find')
          ? 'SearchResults'
          : 'ProviderDetails';
      analytics.calledEvent({
        linkContextPage,
        linkContextComponent: 'DecisionTree',
        clickText: href.replace('tel:', ''),
        clickURL: href,
        ...(provider
          ? { provider, phoneNumber: href.replace('tel:', '') }
          : {}),
        searchCriteria:
          linkContextPage === 'SearchResults'
            ? parseSearchParams(searchParams)
            : undefined,
        filterSpecialtyDisplayName:
          linkContextPage === 'SearchResults' ? specialtyNames?.[0] : undefined,
      });
    },
    [analytics, pathname, searchParams, provider, specialtyNames],
  );
};
